import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { DeclareFields } from "boomform";
import { undoable } from "../helpers/undoable";

import reducer from "./rootReducer";
import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose;
        __REDUX_DEVTOOLS_EXTENSION__: typeof compose;
        __current_form_state: any;
        declareFields: DeclareFields;
        handleChange: any;
        updateId: any;
        blockFieldUpdate: number;
    }
}

const persistConfig = {
    key: "root",
    storage,
    // whitelist: ["ui", "pages", "fields"],
    whitelist: [],
};

const persistedReducer = persistReducer(persistConfig, undoable(combineReducers(reducer)));

const configureStore = (initialState: { [key: string]: never } = {}) => {
    const composeEnhancers =
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || window.__REDUX_DEVTOOLS_EXTENSION__ || compose;

    const store = createStore(persistedReducer, initialState, composeEnhancers(applyMiddleware(sagaMiddleware)));

    sagaMiddleware.run(rootSaga);

    return { store };
};

export const { store } = configureStore();
export const persistor = persistStore(store);
